module.exports = __webpack_public_path__ + "static/media/background.cc4e527c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background.jpg
// module id = 155
// module chunks = 0